import SignupRequestFlow, { OrgTreeNode } from "./components/SignupRequestFlow"
import StatusScreen, { StatusScreenProps } from "./components/StatusScreen"
import type { Department } from "./components/request/types"

type SignupProps = {
  variant: "signup"
  org_name: string
  profile: {
    name: string
    email: string
  }
  org_tree: OrgTreeNode[]
  departments: Department[]
  errors?: Record<string, string | string[]>
}

type StatusProps = StatusScreenProps & { variant: "status" }

type Props = SignupProps | StatusProps

// One /onboarding page, variants driven by OnboardingController:
// - "signup": self-signup — confirm profile, request access from admins
// - "status": request submitted, no roles yet — awaiting review or declined
export default function Show(props: Props) {
  if (props.variant === "signup") {
    return (
      <SignupRequestFlow
        org_name={props.org_name}
        profile={props.profile}
        org_tree={props.org_tree}
        departments={props.departments}
        errors={props.errors}
      />
    )
  }

  const { variant: _variant, ...rest } = props
  return <StatusScreen {...rest} />
}
